import API from "lib/api"
import { GetStaticPropsContext } from "next"
import ProductIndex from "partials/product-index"
import { Category, ProductsPaginated, SubCategory } from "types"
import Breadcrumbs from "@/components/breadcrumbs"
import Layout from "@/components/layout"
import PageHeader from "@/components/page-header"

export type PageProps = {
  products: ProductsPaginated
  categories: Category
  currentCategory: SubCategory
}

export type Props = {
  products: ProductsPaginated
  currentCategory?: SubCategory
  title: string
  basePath: string
  filters?: {
    categories?: Category
  }
}

export const Component = ({
  title,
  basePath,
  products,
  currentCategory,
  filters,
}: Props) => {
  return (
    <Layout title={title}>
      <PageHeader title={currentCategory ? currentCategory.name : title} />
      <Breadcrumbs
        current={
          currentCategory
            ? [
                {
                  url: `/${basePath}`,
                  title,
                },
                {
                  title: currentCategory.name,
                },
              ]
            : title
        }
      />
      <ProductIndex
        products={products}
        filters={filters}
        rawPath={basePath}
        currentCategory={currentCategory}
        basePath={
          currentCategory
            ? `${basePath}/category/${
                currentCategory ? currentCategory.slug : ""
              }`
            : basePath
        }
      />
    </Layout>
  )
}

export const loadStaticProps = async (
  context: GetStaticPropsContext,
  categorySlug: string,
) => {
  let currentCategory = null
  const categories = await API.services.categories.single(categorySlug)

  if (context.params?.slug) {
    currentCategory = await API.services.categories.subCategory(
      categories.slug,
      String(context.params.slug),
    )
  }

  const products = await API.services.products.index({
    page: Number(context.params?.page || 1),
    main_category_id: categories.id,
    sub_categories: currentCategory ? [currentCategory.id] : [],
    component_type: context.params?.componentType
      ? String(context.params.componentType)
      : undefined,
  })

  return {
    products,
    currentCategory,
    filters: { categories },
  }
}
